export interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
  zone?: '一区' | '二区';
  description: string;
}

export interface Zone {
  id: string;
  name: string;
  slug: string;
  label: string;
  description: string;
}

export const zones: Zone[] = [
  {
    id: 'zone-jp',
    name: '一区',
    slug: 'zone-jp',
    label: '日本区',
    description: '汇聚日本顶尖教育资源，覆盖语言、职场、文化、学历提升等全方位课程体系',
  },
  {
    id: 'zone-kr',
    name: '二区',
    slug: 'zone-kr',
    label: '韩国区',
    description: '整合韩国优质教育资源，从语言入门到职场进阶，一站式满足学习需求',
  },
];

export const categories: Category[] = [
  {
    id: 'cat-language',
    name: '语言课程',
    slug: 'language',
    icon: 'ri-translate-2',
    description: '日韩语言系统学习，从零基础到高级，覆盖JLPT与TOPIK全级别',
  },
  {
    id: 'cat-career',
    name: '职场培训',
    slug: 'career',
    icon: 'ri-briefcase-4-line',
    description: '商务日语韩语、职场礼仪、面试技巧，助你在日韩职场脱颖而出',
  },
  {
    id: 'cat-culture',
    name: '文化教育',
    slug: 'culture',
    icon: 'ri-global-line',
    description: '深入日韩传统文化与现代流行文化，拓宽国际视野',
  },
  {
    id: 'cat-degree',
    name: '学历提升',
    slug: 'degree',
    icon: 'ri-graduation-cap-line',
    description: '日韩名校留学申请指导，本科至博士全阶段覆盖',
  },
  {
    id: 'cat-exam',
    name: '资格考试',
    slug: 'exam',
    icon: 'ri-file-text-line',
    description: 'JLPT、TOPIK等权威考试专项辅导，精准突破高分',
  },
];

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find(c => c.slug === slug);
};

export const getZoneBySlug = (slug: string): Zone | undefined => {
  return zones.find(z => z.slug === slug);
};